module.exports = __webpack_public_path__ + "img/logokindernino.dc525818.png";